import { WidgetUrl } from './Constants/Constants';

export const getRedirectUrl = (tableName, id, additionalDetails) => {
  switch (tableName) {
    case 'Project':
      return {
        viewUrl: WidgetUrl.project.view(id),
        editUrl: WidgetUrl.project.edit(id),
        task: {
          openTaskPopup: true,
          taskProjectId: id,
          tableName: tableName,
        },
      };

    case 'Tasks':
      return {
        task: {
          openTaskPopup: true,
          taskProjectId: id,
          tableName: tableName,
        },
      };
    case 'Quotes':
      return {
        viewUrl: WidgetUrl.quote.view(
          additionalDetails.customerId,
          additionalDetails.opportunityId,
          id
        ),
        editUrl: WidgetUrl.quote.edit(
          additionalDetails.customerId,
          additionalDetails.opportunityId,
          id
        ),
      };
    case 'Opportunity':
      return {
        viewUrl: WidgetUrl.lead.view(
          additionalDetails.customerId,
          additionalDetails.opportunityId
        ),
        editUrl: WidgetUrl.lead.edit(
          additionalDetails.customerId,
          additionalDetails.opportunityId
        ),
      };
    case 'Chargebacks':
      if (
        additionalDetails?.secondaryObject?.secondaryTable &&
        additionalDetails?.secondaryObject?.secondaryId
      ) {
        return {
          viewUrl: WidgetUrl.chargeback.projectChargebackViewUrl(
            additionalDetails?.secondaryObject?.secondaryId
          ),
          editUrl: WidgetUrl.chargeback.projectChargebackEditUrl(
            additionalDetails?.secondaryObject?.secondaryId
          ),
        };
      } else {
        return {
          viewUrl: WidgetUrl.chargeback.chargebackViewUrl(id),
          editUrl: WidgetUrl.chargeback.chargebackEditUrl(id),
        };
      }
    case 'SupportTicket':
      return {
        viewUrl: WidgetUrl.supportTicket.view(id),
      };
    default:
      return null;
  }
};
